class epg_item {
  constructor(id = "id", events = true) {
    this.id = id;
    this.events = events;
  }
}

export default epg_item;
